var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attachment-manager",
    class: {
      'attachment-manager--has-controls': _vm.hasControls
    }
  }, [(_vm.internalValue && _vm.internalValue.length) ? _c('table', {
    staticClass: "uk-table uk-table-divider uk-margin-remove uk-table-middle"
  }, [_c('thead', [_c('tr', [(_vm.hasControls) ? _c('th', {
    staticClass: "uk-table-shrink"
  }) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.thumb')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.fileName')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.remoteAttachment')))]), _vm._v(" "), (_vm.hasControls) ? _c('th', [_vm._v(_vm._s(_vm.$t('fields.heroImage')))]) : _vm._e(), _vm._v(" "), (_vm.hasControls) ? _c('th', [_vm._v("Sichtbar")]) : _vm._e(), _vm._v(" "), (_vm.hasControls) ? _c('th') : _vm._e()])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "tbody",
      "options": {
        handle: '.drag-handle'
      }
    },
    on: {
      "end": _vm.onInput
    },
    model: {
      value: (_vm.internalValue),
      callback: function($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue"
    }
  }, _vm._l((_vm.internalValue), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "attachment-manager__row"
    }, [(_vm.hasControls) ? _c('td', {
      staticClass: "uk-table-preserve-width"
    }, [_c('drag-handle', {
      attrs: {
        "disabled": !_vm.orderable
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "attachment-manager__thumbnail-cell"
    }, [_c('thumbnail', {
      attrs: {
        "attachment": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('attachment-name', {
      attrs: {
        "attachment": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('icon', {
      attrs: {
        "title": item.remote,
        "name": _vm.remoteIconName(item)
      }
    })], 1), _vm._v(" "), _c('td', [_c('Checkbox', {
      on: {
        "change": function($event) {
          _vm.setHeroImageAttachment($event, item)
        }
      },
      model: {
        value: (item.isHeroImage),
        callback: function($$v) {
          item.isHeroImage = $$v
        },
        expression: "item.isHeroImage"
      }
    })], 1), _vm._v(" "), _c('td', [_c('Checkbox', {
      model: {
        value: (item.isVisible),
        callback: function($$v) {
          item.isVisible = $$v
        },
        expression: "item.isVisible"
      }
    })], 1), _vm._v(" "), (_vm.hasControls) ? _c('td', [_c('data-grid-actions', {
      attrs: {
        "edit-route": {
          name: 'edit-attachment',
          params: {
            id: item.id
          }
        }
      },
      on: {
        "remove": function($event) {
          _vm.removeAttachmentWhenConfirmed(index)
        }
      }
    })], 1) : _vm._e()])
  })), _vm._v(" "), (_vm.hasControls) ? _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "uk-padding-remove-left uk-padding-remove-right",
    attrs: {
      "colspan": "4"
    }
  }, [_c('file-upload-button', {
    attrs: {
      "attachment-type": _vm.attachmentType,
      "multiple": "",
      "disabled": _vm.disabled
    },
    on: {
      "upload": _vm.addUploadedAttachments
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "album",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.$refs.picker.show()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('actions.select')) + "\n          ")])], 1)])]) : _vm._e()], 1) : _c('div', {
    staticClass: "uk-placeholder uk-text-center uk-margin-remove"
  }, [_c('div', [_vm._t("empty", [_vm._v("\n        " + _vm._s(_vm.$t('hints.empty')) + "\n      ")])], 2), _vm._v(" "), (_vm.hasControls) ? _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('file-upload-button', {
    attrs: {
      "attachment-type": _vm.attachmentType,
      "multiple": ""
    },
    on: {
      "upload": _vm.addUploadedAttachments
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "album"
    },
    on: {
      "click": function($event) {
        _vm.$refs.picker.show()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.select')) + "\n      ")])], 1) : _vm._e()]), _vm._v(" "), _c('attachment-picker', {
    ref: "picker",
    attrs: {
      "attachment-type": _vm.attachmentType,
      "selected-attachment-ids": _vm.selectedAttachmentIds
    },
    on: {
      "select": _vm.addAttachments
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a1c89f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttachmentManager.vue
// module id = 1869
// module chunks = 0